(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advertorial-shell"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const shell = document.querySelector('[data-advertorial-shell]');
    const main = shell?.closest('main') || document.querySelector('#MainContent');
    if (shell?.dataset.articleLayout === 'true' && main) {
      main.classList.add('advx-article-layout');
      const sidebarSection = main.querySelector('.advx-sidebar')?.closest('.shopify-section');
      const heroSection = main.querySelector('.advx-hero')?.closest('.shopify-section');
      const alignArticleRail = () => {
        if (!sidebarSection || !heroSection) return;
        main.style.setProperty('--advx-article-start', `${heroSection.offsetTop}px`);
      };
      window.addEventListener('resize', alignArticleRail);
      alignArticleRail();
    }

    const progress = document.querySelector('[data-advertorial-progress]');
    if (!progress) return;
    let queued = false;
    const update = () => {
      const maximum = document.documentElement.scrollHeight - window.innerHeight;
      const ratio = maximum > 0 ? Math.min(window.scrollY / maximum, 1) : 0;
      progress.style.transform = `scaleX(${ratio})`;
      queued = false;
    };
    window.addEventListener('scroll', () => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glare-adv-close"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const stickyBars = document.querySelectorAll('[data-gla-sticky]');
    if (!stickyBars.length) return;

    const update = () => {
      stickyBars.forEach((bar) => {
        const threshold = Number(bar.dataset.showAfter || 900);
        bar.classList.toggle('is-visible', window.scrollY > threshold);
      });
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glare-adv-styles"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const progressBars = document.querySelectorAll('[data-gla-progress]');
    if (!progressBars.length) return;

    const update = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollable > 0 ? Math.min(window.scrollY / scrollable, 1) : 0;
      progressBars.forEach((bar) => {
        bar.style.transform = `scaleX(${progress})`;
      });
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glare-sv-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const progress = document.querySelector('[data-gsv-progress]');
    if (!progress) return;
    let ticking = false;
    const update = () => {
      const maximum = document.documentElement.scrollHeight - window.innerHeight;
      const ratio = maximum > 0 ? Math.min(window.scrollY / maximum, 1) : 0;
      progress.style.transform = `scaleX(${ratio})`;
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glare-sv-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sticky = document.querySelector('[data-gsv-sticky]');
    const reveal = document.querySelector('[data-gsv-product-reveal]');
    if (!sticky || !reveal) return;
    sticky.hidden = false;
    let ticking = false;
    const update = () => {
      const threshold = reveal.getBoundingClientRect().bottom + window.scrollY;
      sticky.classList.toggle('is-visible', window.scrollY > threshold);
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sean-wit-buybox"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-swp-countdown]').forEach(function (timer) {
    var deadlineValue = timer.getAttribute('data-deadline');
    var expiredText = timer.getAttribute('data-expired-text') || 'Offer ended';

    if (!deadlineValue) {
      return;
    }

    var deadline = new Date(deadlineValue).getTime();

    if (!deadline) {
      return;
    }

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function updateTimer() {
      var distance = deadline - Date.now();

      if (distance <= 0) {
        timer.textContent = expiredText;
        return;
      }

      var days = Math.floor(distance / 86400000);
      var hours = Math.floor((distance % 86400000) / 3600000);
      var minutes = Math.floor((distance % 3600000) / 60000);
      var seconds = Math.floor((distance % 60000) / 1000);

      timer.textContent = days + 'd ' + pad(hours) + 'h ' + pad(minutes) + 'm ' + pad(seconds) + 's';
      window.requestAnimationFrame(function () {
        window.setTimeout(updateTimer, 250);
      });
    }

    updateTimer();
  });

  } catch(e) { console.error(e); }
})();
})();
